import React from "react";
import WagerTypes from "../constants/WagerTypes";
import EntryColor from "./EntryColor";

const EntriesTable = ({
  raceInfo,
  entriesInfo,
  wt,
  idWT,
  idBox,
  addToCart,
  disabledAll,
  checkBoxState,
  pickName,
  positionLeg,
  raceID,
}) => {
  let tableContent = [];
  let wagerType = [],
    headers,
    MLt;

  //Coloca el th para WIN/PLACE/SHOW con checkbox o sin checkbox
  if (raceInfo) {
    let race = [raceInfo];
    race.forEach((item, i) => {
      if (raceInfo.RaceStatus === "O") {
        if (item["Win"]) {
          wagerType.push(
            <th key={"Win" + i}>
              <input
                key="Win"
                type="checkbox"
                id="chkWin"
                name="chkWinHeader"
                value=""
                onClick={(e) => checkedAll(e)}
              ></input>{" "}
              W
            </th>
          );
        }
      }
      if (raceInfo.RaceStatus === "O") {
        if (item["Place"]) {
          wagerType.push(
            <th key={"place" + i}>
              <input
                key="Place"
                type="checkbox"
                id="chkPlace"
                name="chkPlaceHeader"
                value=""
                onClick={(e) => checkedAll(e)}
              ></input>{" "}
              P
            </th>
          );
        }
      }
      if (raceInfo.RaceStatus === "O") {
        if (item["Show"]) {
          wagerType.push(
            <th key={"show" + i}>
              <input
                key="Show"
                type="checkbox"
                id="chkShow"
                name="chkShowHeader"
                value=""
                onClick={(e) => checkedAll(e)}
              ></input>{" "}
              S
            </th>
          );
        }
      }
    });
  }

  //Sacar 2 decimales
  function trunc(n) {
    let t = n.toString();
    let regex = /(\d*.\d{0,2})/;
    return t.match(regex)[0];
  }

  //Función para hacer check horizontal en la tabla de entries
  const checkedAllWT = (saddleNum, event) => {
    let checkbox = document.querySelectorAll(
      '[saddlenum="' + saddleNum + '"]:not(input[name=chkBox])'
    );

    for (var i = 0, n = checkbox.length; i < n; i++) {
      checkbox[i].checked = event.target.checked;
      if (
        parseInt(checkbox[i].getAttribute("idwt")) === WagerTypes.WIN.id ||
        parseInt(checkbox[i].getAttribute("idwt")) === WagerTypes.PLACE.id ||
        parseInt(checkbox[i].getAttribute("idwt")) === WagerTypes.SHOW.id
      ) {
        addToCart(checkbox[i], false, i);
      } else {
        addToCart(checkbox[i], false, 0);
      }
    }
  };

  //Función para marcar checkbox verticales desde el checkbox principal
  const checkedAll = (event) => {
    if (event.target.id === "chkBox") {
      disabledAll(event.target);
    }

    let checkbox = [
      ...document.querySelectorAll("input[name='" + event.target.id + "']"),
    ];

    if (
      event.target.id === "chkWin" ||
      event.target.id === "chkPlace" ||
      event.target.id === "chkShow"
    ) {
      for (let i = 0; i < checkbox.length; i++) {
        const element = checkbox[i];
        element.checked = event.target.checked;
        (function (element) {
          addToCart(element, false, i);
        })(element);
      }
    } else {
      checkbox.map((element) => {
        if (
          parseInt(element.getAttribute("raceid")) ===
          parseInt(event.target.getAttribute("raceid"))
        ) {
          element.checked = event.target.checked;
          addToCart(element, false, 0);
        }
      });
    }
  };

  //Llena la tabla de los entries
  if (entriesInfo) {
    let stylePick;
    if (
      wt === pickName ||
      wt === WagerTypes.DAILYDOUBLE.name ||
      wt === WagerTypes.GRANDSLAM.name
    ) {
      stylePick = { width: "130px", wordWrap: "break-word !important" };
    }
    tableContent = entriesInfo.map((data, i) => {
      if (data.ML !== 0) {
        MLt = trunc(data.ML, 2);
      }

      //CHECKBOX PARA CADA COLUMNA SEGÚN WT (Childs)
      let checkAllH,
        chkBoxWin,
        chkBoxPlace,
        chkBoxShow,
        chkBoxPos1,
        chkBoxPos2,
        chkBoxPos3,
        chkBoxPos4,
        chkBoxPos5,
        chkTicketPlay1,
        chkBoxDD,
        chkBoxOmni,
        chkBoxColumn,
        chkBoxPick,
        chkBoxGsl,
        positionChkPos2;
      if (wt === WagerTypes.QUINELLA.name || wt === WagerTypes.HOUSEQ.name) {
        positionChkPos2 = 1;
      } else {
        positionChkPos2 = 3;
      }

      //Muestra el Checkbox si el caballo no esta scratch
      if (data.FinishPos === 0 && raceInfo.RaceStatus === "O") {
        checkAllH = (
          <input
            key={"All" + i}
            type="checkbox"
            id="chkAllH"
            name="chkAllH"
            value=""
            className="form-control chkAllH"
            style={{ height: "20px" }}
            onClick={(e) => checkedAllWT(data.SaddleNum, e)}
          ></input>
        );
        chkBoxWin = (
          <input
            key={"chk" + i}
            type="checkbox"
            id="chkWin"
            name="chkWin"
            value=""
            style={{ height: "20px" }}
            className="form-control chkWin"
            idwt={idWT.Win}
            saddlenum={data.SaddleNum}
            entrynum={data.EntryNum}
            entryname={data.EntryName}
            raceid={data.RaceID}
            position={0}
            onClick={(e) => addToCart(e.target, true, 0)}
          ></input>
        );
        chkBoxPlace = (
          <input
            key={"Place" + i}
            type="checkbox"
            id={"chkPlace"}
            name="chkPlace"
            value=""
            style={{ height: "20px" }}
            className="form-control"
            idwt={idWT.Place}
            saddlenum={data.SaddleNum}
            entrynum={data.EntryNum}
            entryname={data.EntryName}
            raceid={data.RaceID}
            position={0}
            onClick={(e) => addToCart(e.target, true, 0)}
          ></input>
        );
        chkBoxShow = (
          <input
            key={"Show" + i}
            type="checkbox"
            id="chkShow"
            name="chkShow"
            value=""
            className="form-control"
            style={{ height: "20px" }}
            idwt={idWT.Show}
            saddlenum={data.SaddleNum}
            entrynum={data.EntryNum}
            entryname={data.EntryName}
            raceid={data.RaceID}
            position={0}
            onClick={(e) => addToCart(e.target, true, 0)}
          ></input>
        );
        chkTicketPlay1 = (
          <input
            key={"chkTP1" + i}
            type="checkbox"
            id="chkTP1"
            name="chkTP1"
            value=""
            style={{ height: "20px" }}
            className="form-control"
            idwt={idWT}
            saddlenum={data.SaddleNum}
            entrynum={data.EntryNum}
            entryname={data.EntryName}
            raceid={data.RaceID}
            position={1}
            onClick={(e) => addToCart(e.target, true, 0)}
          ></input>
        );
        chkBoxPos1 = (
          <input
            key={"chk" + i}
            type="checkbox"
            id="chk"
            name="chk1"
            value=""
            style={{ height: "20px" }}
            className="form-control"
            idwt={idWT}
            saddlenum={data.SaddleNum}
            entrynum={data.EntryNum}
            entryname={data.EntryName}
            raceid={data.RaceID}
            position={0}
            onClick={(e) => addToCart(e.target, true, 0)}
          ></input>
        );
        chkBoxPos2 = (
          <input
            key={"chk2" + i}
            type="checkbox"
            id="chk"
            name="chk2"
            value=""
            style={{ height: "20px" }}
            className="form-control"
            idwt={idWT}
            saddlenum={data.SaddleNum}
            entrynum={data.EntryNum}
            entryname={data.EntryName}
            raceid={data.RaceID}
            position={positionChkPos2}
            onClick={(e) => addToCart(e.target, true, 0)}
          ></input>
        );
        chkBoxPos3 = (
          <input
            key={"chk3" + i}
            type="checkbox"
            id="chk"
            name="chk3"
            value=""
            style={{ height: "20px" }}
            className="form-control"
            idwt={idWT}
            saddlenum={data.SaddleNum}
            entrynum={data.EntryNum}
            entryname={data.EntryName}
            raceid={data.RaceID}
            position={4}
            onClick={(e) => addToCart(e.target, true, 0)}
          ></input>
        );
        chkBoxPos4 = (
          <input
            key={"chk4" + i}
            type="checkbox"
            id="chk"
            name="chk4"
            value=""
            style={{ height: "20px" }}
            className="form-control"
            idwt={idWT}
            saddlenum={data.SaddleNum}
            entrynum={data.EntryNum}
            entryname={data.EntryName}
            raceid={data.RaceID}
            position={5}
            onClick={(e) => addToCart(e.target, true, 0)}
          ></input>
        );
        chkBoxPos5 = (
          <input
            key={"chk5" + i}
            type="checkbox"
            id="chk"
            name="chk5"
            value=""
            style={{ height: "20px" }}
            className="form-control"
            idwt={idWT}
            saddlenum={data.SaddleNum}
            entrynum={data.EntryNum}
            entryname={data.EntryName}
            raceid={data.RaceID}
            position={6}
            onClick={(e) => addToCart(e.target, true, 0)}
          ></input>
        );
        chkBoxDD = (
          <input
            key={"Dd" + i}
            type="checkbox"
            id="chk"
            name="chkDd"
            value=""
            style={{ height: "20px" }}
            className="form-control"
            idwt={idWT}
            saddlenum={data.SaddleNum}
            entrynum={data.EntryNum}
            entryname={data.EntryName}
            raceid={data.RaceID}
            position={positionLeg}
            racenum={data.RaceNumber}
            onClick={(e) => addToCart(e.target, true, 0)}
          ></input>
        );
        chkBoxPick = (
          <input
            key={"pick" + i}
            type="checkbox"
            id="chk"
            name="chkPick"
            value=""
            style={{ height: "20px" }}
            className="form-control"
            idwt={idWT}
            saddlenum={data.SaddleNum}
            entrynum={data.EntryNum}
            entryname={data.EntryName}
            raceid={data.RaceID}
            position={positionLeg}
            racenum={data.RaceNumber}
            onClick={(e) => addToCart(e.target, true, 0)}
          ></input>
        );
        chkBoxGsl = (
          <input
            key={"chkGsl" + i}
            type="checkbox"
            id="chk"
            name="chkGsl"
            value=""
            style={{ height: "20px" }}
            className="form-control"
            idwt={idWT}
            saddlenum={data.SaddleNum}
            entrynum={data.EntryNum}
            entryname={data.EntryName}
            raceid={data.RaceID}
            position={positionLeg}
            racenum={data.RaceNumber}
            onClick={(e) => addToCart(e.target, true, 0)}
          ></input>
        );
        chkBoxOmni = (
          <input
            key={"omni" + i}
            type="checkbox"
            id="chk"
            name="chkOmni"
            value=""
            style={{ height: "20px" }}
            className="form-control"
            idwt={idWT}
            saddlenum={data.SaddleNum}
            entrynum={data.EntryNum}
            entryname={data.EntryName}
            raceid={data.RaceID}
            position={0}
            onClick={(e) => addToCart(e.target, true, 0)}
          ></input>
        );
        chkBoxColumn = (
          <input
            key={"Box" + i}
            type="checkbox"
            id="chk"
            name="chkBox"
            value=""
            style={{ height: "20px" }}
            className="form-control"
            idwt={idBox}
            saddlenum={data.SaddleNum}
            entrynum={data.EntryNum}
            entryname={data.EntryName}
            raceid={data.RaceID}
            position={0}
            onClick={(e) => addToCart(e.target, true, 0)}
            disabled={checkBoxState}
          ></input>
        );
      }

      return (
        <React.Fragment key={i}>
          <tr
            key={"tr" + data.EntryID}
            style={{ verticalAlign: "middle" }}
            className={"entryTR"}
          >
            <td className="d-none">{data.EntryID}</td>
            <td className="d-none">{data.RaceID}</td>
            {raceInfo.RaceStatus === "O" &&
              wt !== WagerTypes.DAILYDOUBLE.name &&
              wt !== WagerTypes.OMNI.name &&
              wt !== pickName &&
              wt !== WagerTypes.GRANDSLAM.name && (
                <td
                  key={"td" + data.EntryID}
                  style={{
                    textAlign: "center",
                    width: "40px",
                    verticalAlign: "middle",
                  }}
                >
                  {checkAllH}
                </td>
              )}
            <td
              key={"saddle" + data.EntryID}
              style={{
                textAlign: "center",
                verticalAlign: "middle",
                width: "40px",
              }}
            >
              <EntryColor
                entryNum={data.EntryNum}
                saddleNum={data.SaddleNum}
                finishPos={data.FinishPos}
              />
            </td>
            {data.FinishPos !== -1 ? (
              <>
                <td
                  key={"mlOdds" + data.EntryID}
                  style={{
                    verticalAlign: "middle",
                    textAlign: "center",
                  }}
                >
                  <p
                    key={"Odds" + data.EntryID}
                    style={{ marginBottom: "2px", marginTop: "5px" }}
                  >
                    {data.Odds.WinOdds}
                  </p>
                  <p key={"ML" + data.EntryID} style={{ fontSize: "12px" }}>
                    ML: {MLt}
                  </p>
                </td>
                <td
                  key={"td" + data.EntryID}
                  style={{
                    textAlign: "center",
                    verticalAlign: "middle",
                  }}
                >
                  <label
                    className="hoverFontHorse pNormal"
                    style={{
                      fontSize: "16px",
                      textDecoration: "none",
                    }}
                    href="#!"
                    data-toggle="collapse"
                    data-target={"#collapseStatistics" + data.EntryID}
                    aria-expanded="false"
                    key={"horse" + data.EntryID}
                  >
                    {data.EntryName}
                  </label>
                </td>
                <td
                  key={"tdr" + data.EntryID}
                  style={{
                    textAlign: "center",
                    verticalAlign: "middle",
                  }}
                >
                  <label
                    className="pNormal"
                    style={{
                      fontSize: "16px",
                      textDecoration: "none",
                      stylePick,
                      color: "#495057",
                    }}
                    key={"rider" + data.EntryID}
                  >
                    {data.RiderName}
                  </label>
                </td>
              </>
            ) : (
              <>
                <td
                  key={"mlOdds" + data.EntryID}
                  style={{
                    verticalAlign: "middle",
                    textAlign: "center",
                    color: "#a6a6a6",
                  }}
                >
                  <p
                    key={"Odds" + data.EntryID}
                    style={{ marginBottom: "2px", marginTop: "5px" }}
                  >
                    {data.Odds.WinOdds}
                  </p>
                  <p key={"ML" + data.EntryID} style={{ fontSize: "12px" }}>
                    ML: {MLt}
                  </p>
                </td>
                <td
                  key={"td" + data.EntryName}
                  style={{
                    textAlign: "center",
                    verticalAlign: "middle",
                  }}
                >
                  <label
                    className="hoverFontHorseDisabled pNormal"
                    style={{
                      fontSize: "16px",
                      textDecoration: "none",
                      stylePick,
                    }}
                    href="#!"
                    data-toggle="collapse"
                    data-target={"#collapseStatistics" + data.EntryID}
                    aria-expanded="false"
                    key={"horse" + data.EntryID}
                  >
                    {data.EntryName}
                  </label>
                </td>
                <td
                  key={"td" + data.RiderName}
                  style={{
                    textAlign: "center",
                    verticalAlign: "middle",
                  }}
                >
                  <label
                    className=" pNormal"
                    style={{
                      fontSize: "16px",
                      textDecoration: "none",
                      stylePick,
                      color: "#a6a6a6",
                    }}
                    key={"rider" + data.EntryID}
                  >
                    {data.RiderName}
                  </label>
                </td>
              </>
            )}

            {/* td para WPS */}
            {raceInfo.RaceStatus === "O" && wt === WagerTypes.WPS.name && (
              <React.Fragment key={i}>
                <td
                  style={{ textAlign: "center", verticalAlign: "middle" }}
                  key={"win" + data.EntryID}
                >
                  {raceInfo.Win && (
                    <React.Fragment key={i}>
                      {chkBoxWin}
                      {wt === WagerTypes.WPS.name &&
                        data.FinishPos !== -1 &&
                        data.Odds.WinTotal !== 0 && (
                          <span style={{ fontSize: "12px" }}>
                            ${data.Odds.WinTotal}
                          </span>
                        )}
                    </React.Fragment>
                  )}
                </td>
                <td
                  style={{ textAlign: "center", verticalAlign: "middle" }}
                  key={"place" + data.EntryID}
                >
                  {raceInfo.Place && (
                    <React.Fragment key={i}>
                      {chkBoxPlace}
                      {wt === WagerTypes.WPS.name &&
                        data.FinishPos !== -1 &&
                        data.Odds.WinTotal !== 0 && (
                          <span style={{ fontSize: "12px" }}>
                            ${data.Odds.PlaceTotal}
                          </span>
                        )}
                    </React.Fragment>
                  )}
                </td>
                <td
                  style={{ textAlign: "center", verticalAlign: "middle" }}
                  key={"show" + data.EntryID}
                >
                  {raceInfo.Show && wt === WagerTypes.WPS.name && (
                    <React.Fragment key={i}>
                      {chkBoxShow}
                      {wt === WagerTypes.WPS.name &&
                        data.FinishPos !== -1 &&
                        data.Odds.WinTotal !== 0 && (
                          <span style={{ fontSize: "12px" }}>
                            ${data.Odds.ShowTotal}
                          </span>
                        )}
                    </React.Fragment>
                  )}
                </td>
              </React.Fragment>
            )}
            {raceInfo.RaceStatus === "O" &&
              wt !== WagerTypes.WPS.name &&
              wt !== WagerTypes.DAILYDOUBLE.name &&
              wt !== WagerTypes.OMNI.name &&
              wt !== pickName &&
              wt !== WagerTypes.GRANDSLAM.name &&
              wt !== WagerTypes.QUINELLA.name &&
              wt !== WagerTypes.HOUSEQ.name && (
                <React.Fragment key={i}>
                  {/* td para EXACTA */}
                  <td
                    style={{ textAlign: "center", verticalAlign: "middle" }}
                    key={"chk1" + data.EntryID}
                  >
                    {chkBoxPos1}
                  </td>
                  <td
                    style={{ textAlign: "center", verticalAlign: "middle" }}
                    key={"chk2" + data.EntryID}
                  >
                    {chkBoxPos2}
                  </td>
                  {/* TRIFECTA */}
                  {raceInfo.RaceStatus === "O" &&
                    wt === WagerTypes.TRIFECTA.name && (
                      <td
                        style={{
                          textAlign: "center",
                          verticalAlign: "middle",
                        }}
                        key={"chk3" + data.EntryID}
                      >
                        {chkBoxPos3}
                      </td>
                    )}
                  {/* SUPERFECTA */}
                  {raceInfo.RaceStatus === "O" &&
                    wt === WagerTypes.SUPERFECTA.name && (
                      <React.Fragment key={i}>
                        <td
                          style={{
                            textAlign: "center",
                            verticalAlign: "middle",
                          }}
                          key={"chk3" + data.EntryID}
                        >
                          {chkBoxPos3}
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            verticalAlign: "middle",
                          }}
                          key={"chk4" + data.EntryID}
                        >
                          {chkBoxPos4}
                        </td>
                      </React.Fragment>
                    )}
                  {/* High5 */}
                  {raceInfo.RaceStatus === "O" &&
                    wt === WagerTypes.HIGH5.name && (
                      <React.Fragment key={i}>
                        <td
                          style={{
                            textAlign: "center",
                            verticalAlign: "middle",
                          }}
                          key={"chk3" + data.EntryID}
                        >
                          {chkBoxPos3}
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            verticalAlign: "middle",
                          }}
                          key={"chk4" + data.EntryID}
                        >
                          {chkBoxPos4}
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            verticalAlign: "middle",
                          }}
                          key={"chk5" + data.EntryID}
                        >
                          {chkBoxPos5}
                        </td>
                      </React.Fragment>
                    )}
                  {wt !== WagerTypes.HIGH5.name && (
                    <td
                      style={{ textAlign: "center", verticalAlign: "middle" }}
                      key={"box" + data.EntryID}
                    >
                      {chkBoxColumn}
                    </td>
                  )}
                </React.Fragment>
              )}

            {/* QUINELLA */}
            {raceInfo.RaceStatus === "O" && wt === WagerTypes.QUINELLA.name && (
              <React.Fragment key={i}>
                <td
                  style={{
                    textAlign: "center",
                    verticalAlign: "middle",
                  }}
                  key={"chk1" + data.EntryID}
                >
                  {chkBoxPos1}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    verticalAlign: "middle",
                  }}
                  key={"chk2" + data.EntryID}
                >
                  {chkTicketPlay1}
                </td>
                <td
                  style={{ textAlign: "center", verticalAlign: "middle" }}
                  key={"box" + data.EntryID}
                >
                  {chkBoxColumn}
                </td>
              </React.Fragment>
            )}

            {/* HOUSEQUINELLA */}
            {raceInfo.RaceStatus === "O" && wt === WagerTypes.HOUSEQ.name && (
              <React.Fragment key={i}>
                <td
                  style={{
                    textAlign: "center",
                    verticalAlign: "middle",
                  }}
                  key={"chk1" + data.EntryID}
                >
                  {chkBoxPos1}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    verticalAlign: "middle",
                  }}
                  key={"chk2" + data.EntryID}
                >
                  {chkTicketPlay1}
                </td>
                <td
                  style={{ textAlign: "center", verticalAlign: "middle" }}
                  key={"box" + data.EntryID}
                >
                  {chkBoxColumn}
                </td>
              </React.Fragment>
            )}

            {/* DAYLY DOUBLE */}
            {raceInfo.RaceStatus === "O" &&
              wt === WagerTypes.DAILYDOUBLE.name && (
                <td
                  style={{ textAlign: "center", verticalAlign: "middle" }}
                  key={"dd" + data.EntryID}
                >
                  {chkBoxDD}
                </td>
              )}
            {/* OMNI */}
            {raceInfo.RaceStatus === "O" && wt === WagerTypes.OMNI.name && (
              <td
                style={{ textAlign: "center", verticalAlign: "middle" }}
                key={"omni" + data.EntryID}
              >
                {chkBoxOmni}
              </td>
            )}

            {/* PICKS */}
            {raceInfo.RaceStatus === "O" && wt === pickName && (
              <td
                style={{ textAlign: "center", verticalAlign: "middle" }}
                key={"pick" + data.EntryID}
              >
                {chkBoxPick}
              </td>
            )}

            {/* GRANDSLAM */}
            {raceInfo.RaceStatus === "O" &&
              wt === WagerTypes.GRANDSLAM.name && (
                <td
                  style={{ textAlign: "center", verticalAlign: "middle" }}
                  key={"gsl" + data.EntryID}
                >
                  {chkBoxGsl}
                </td>
              )}
          </tr>
          <tr
            id={"collapseStatistics" + data.EntryID}
            className="collapse card-body"
            aria-labelledby="headingDetails"
            style={{
              textAlign: "left",
              padding: "5px",
            }}
            key={"statistics" + data.EntryID}
          >
            <td
              colSpan={6}
              key={"statisticsH" + data.EntryID}
              style={{ whiteSpace: "unset" }}
            >
              <div className="row">
                <div className="col-sm-6">
                  <p
                    className=""
                    style={{ fontSize: "14px" }}
                    key={"trainer" + data.EntryID}
                  >
                    <span
                      className="font-weight-bold"
                      style={{ color: "#227190" }}
                    >
                      Trainer:
                    </span>{" "}
                    {data.TrainerName}
                  </p>
                </div>
                <div className="col-sm-6">
                  <p
                    className=""
                    style={{ fontSize: "14px" }}
                    key={"pedigrees" + data.EntryID}
                  >
                    <span
                      className="font-weight-bold"
                      style={{ color: "#227190" }}
                    >
                      Pedigrees:
                    </span>{" "}
                    {data.Pedigrees}
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <p
                    className=""
                    style={{
                      fontSize: "14px",
                      wordWrap: "break-word",
                    }}
                    key={"owner" + data.EntryID}
                  >
                    <span
                      className="font-weight-bold"
                      style={{
                        color: "#227190",
                      }}
                    >
                      Owner:
                    </span>{" "}
                    {data.OwnerName}
                  </p>
                </div>
                <div className="col-sm-6">
                  <p
                    className=""
                    style={{ fontSize: "14px" }}
                    key={"breeders" + data.EntryID}
                  >
                    <span
                      className="font-weight-bold"
                      style={{ color: "#227190" }}
                    >
                      Breeders:
                    </span>{" "}
                    {data.Breeders}
                  </p>
                </div>
              </div>
            </td>
          </tr>
        </React.Fragment>
      );
    });
  }

  //Crea los encabezados de la tabla según el wt

  let principalHeaders;
  principalHeaders = (
    <>
      <th hidden>EntryID</th>
      <th hidden>RaceID</th>
      {raceInfo.RaceStatus === "O" &&
        wt !== pickName &&
        wt !== WagerTypes.GRANDSLAM.name &&
        wt !== WagerTypes.DAILYDOUBLE.name &&
        wt !== WagerTypes.OMNI.name && <th></th>}
      <th style={{ width: "20px" }}>#</th>
      {raceInfo.RaceStatus === "O" ? (
        <>
          <th>Odds</th>
          <th>Horse</th>
        </>
      ) : (
        <>
          <th style={{ width: "60px" }}>Odds</th>
          <th style={{ width: "250px" }}>Horse</th>
        </>
      )}
      <th>Jockey</th>
    </>
  );
  if (wt === WagerTypes.WPS.name) {
    headers = (
      <tr className="text-center header-tbEntries">
        {principalHeaders}
        {wagerType}
      </tr>
    );
  } else if (wt === WagerTypes.EXACTA.name) {
    headers = (
      <tr className="text-center header-tbEntries">
        {principalHeaders}
        {raceInfo.RaceStatus === "O" && (
          <>
            <th>
              <input
                type="checkbox"
                id="chk1"
                name="chk1Header"
                value=""
                key={"exacta1"}
                onClick={(e) => checkedAll(e)}
                raceid={raceInfo.RaceID}
              ></input>{" "}
              1
            </th>
            <th>
              <input
                type="checkbox"
                id="chk2"
                name="chk2Header"
                value=""
                key={"exacta2"}
                onClick={(e) => checkedAll(e)}
                raceid={raceInfo.RaceID}
              ></input>{" "}
              2
            </th>
            <th>
              <input
                type="checkbox"
                id="chkBox"
                name="chkBoxHeader"
                value=""
                key={"box"}
                onClick={(e) => {
                  disabledAll(e.target);
                }}
              ></input>{" "}
              Box
            </th>
          </>
        )}
      </tr>
    );
  } else if (wt === WagerTypes.TRIFECTA.name) {
    headers = (
      <tr className="text-center header-tbEntries">
        {principalHeaders}
        {raceInfo.RaceStatus === "O" && (
          <>
            <th>
              <input
                type="checkbox"
                id="chk1"
                name="chk1Header"
                value="1"
                key={"trifecta1"}
                onClick={(e) => checkedAll(e)}
                raceid={raceInfo.RaceID}
              ></input>{" "}
              1
            </th>
            <th>
              <input
                key={"trifecta2"}
                type="checkbox"
                id="chk2"
                name="chk2Header"
                value="2"
                onClick={(e) => checkedAll(e)}
                raceid={raceInfo.RaceID}
              ></input>{" "}
              2
            </th>
            <th>
              <input
                key={"3"}
                type="checkbox"
                id="chk3"
                name="chk3Header"
                value="3"
                onClick={(e) => checkedAll(e)}
                raceid={raceInfo.RaceID}
              ></input>{" "}
              3
            </th>
            <th>
              <input
                key={"chkBox"}
                type="checkbox"
                id="chkBox"
                name="chkBoxHeader"
                value="box"
                onClick={(e) => {
                  disabledAll(e.target);
                }}
              ></input>{" "}
              Box
            </th>
          </>
        )}
      </tr>
    );
  } else if (wt === WagerTypes.SUPERFECTA.name) {
    headers = (
      <tr className="text-center header-tbEntries">
        {principalHeaders}
        {raceInfo.RaceStatus === "O" && (
          <>
            <th>
              <input
                key={"chkSuperfecta1"}
                type="checkbox"
                id="chk1"
                name="chk1Header"
                value="1"
                onClick={(e) => checkedAll(e)}
                raceid={raceInfo.RaceID}
              ></input>{" "}
              1
            </th>
            <th>
              <input
                key={"chkSuperfecta2"}
                type="checkbox"
                id="chk2"
                name="chk2Header"
                value="2"
                onClick={(e) => checkedAll(e)}
                raceid={raceInfo.RaceID}
              ></input>{" "}
              2
            </th>
            <th>
              <input
                key={"chkSuperfecta3"}
                type="checkbox"
                id="chk3"
                name="chk3Header"
                value="3"
                onClick={(e) => checkedAll(e)}
                raceid={raceInfo.RaceID}
              ></input>{" "}
              3
            </th>
            <th>
              <input
                key={"chkSuperfecta4"}
                type="checkbox"
                id="chk4"
                name="chk4Header"
                value="4"
                onClick={(e) => checkedAll(e)}
                raceid={raceInfo.RaceID}
              ></input>{" "}
              4
            </th>
            <th>
              <input
                key={"chkBoox"}
                type="checkbox"
                id="chkBox"
                name="chkBoxHeader"
                value=""
                onClick={(e) => {
                  disabledAll(e.target);
                }}
              ></input>{" "}
              Box
            </th>
          </>
        )}
      </tr>
    );
  } else if (wt === WagerTypes.HIGH5.name) {
    headers = (
      <tr className="text-center header-tbEntries">
        {principalHeaders}
        {raceInfo.RaceStatus === "O" && (
          <>
            <th>
              <input
                key={"chkHigh5_1"}
                type="checkbox"
                id="chk1"
                name="chk1Header"
                value="1"
                onClick={(e) => checkedAll(e)}
                raceid={raceInfo.RaceID}
              ></input>{" "}
              1
            </th>
            <th>
              <input
                key={"chkHigh5_2"}
                type="checkbox"
                id="chk2"
                name="chk2Header"
                value="2"
                onClick={(e) => checkedAll(e)}
                raceid={raceInfo.RaceID}
              ></input>{" "}
              2
            </th>
            <th>
              <input
                key={"chkHigh5_3"}
                type="checkbox"
                id="chk3"
                name="chk3Header"
                value="3"
                onClick={(e) => checkedAll(e)}
                raceid={raceInfo.RaceID}
              ></input>{" "}
              3
            </th>
            <th>
              <input
                key={"chkHigh5_4"}
                type="checkbox"
                id="chk4"
                name="chk4Header"
                value="4"
                onClick={(e) => checkedAll(e)}
                raceid={raceInfo.RaceID}
              ></input>{" "}
              4
            </th>

            <th>
              <input
                key={"chkHigh5_5"}
                type="checkbox"
                id="chk5"
                name="chk5Header"
                value="5"
                onClick={(e) => checkedAll(e)}
                raceid={raceInfo.RaceID}
              ></input>{" "}
              5
            </th>
          </>
        )}
      </tr>
    );
  } else if (wt === WagerTypes.OMNI.name) {
    headers = (
      <tr className="text-center header-tbEntries">
        {principalHeaders}
        {raceInfo.RaceStatus === "O" && (
          <th>
            <input
              key={"chkOmni1"}
              type="checkbox"
              id="chkOmni"
              name="chkOmniHeader"
              value="1"
              onClick={(e) => checkedAll(e)}
            ></input>{" "}
            OMNI
          </th>
        )}
      </tr>
    );
  } else if (wt === WagerTypes.DAILYDOUBLE.name) {
    headers = (
      <tr className="text-center header-tbEntries">
        {principalHeaders}
        <th>
          {raceInfo.RaceStatus === "O" && (
            <input
              key={"DD"}
              type="checkbox"
              id="chkDd"
              name="chkDdHeader"
              value=""
              raceid={raceID}
              onClick={(e) => checkedAll(e)}
            ></input>
          )}{" "}
          DD
        </th>
      </tr>
    );
  } else if (wt === pickName) {
    headers = (
      <tr className="text-center header-tbEntries">
        {principalHeaders}

        {raceInfo.RaceStatus === "O" && (
          <th>
            <input
              key={"PICK"}
              type="checkbox"
              id="chkPick"
              name="chkPickHeader"
              value=""
              raceid={raceID}
              onClick={(e) => checkedAll(e)}
            ></input>{" "}
            PICK
          </th>
        )}
      </tr>
    );
  } else if (wt === WagerTypes.GRANDSLAM.name) {
    headers = (
      <tr className="text-center header-tbEntries">
        {principalHeaders}

        {raceInfo.RaceStatus === "O" && (
          <th>
            <input
              type="checkbox"
              id="chkGsl"
              name="chkGslHeader"
              value=""
              key={"gsl1"}
              onClick={(e) => checkedAll(e)}
            ></input>{" "}
            GSL
          </th>
        )}
      </tr>
    );
  } else if (wt === WagerTypes.QUINELLA.name || wt === WagerTypes.HOUSEQ.name) {
    headers = (
      <tr className="text-center header-tbEntries">
        {principalHeaders}
        <th>
          <input
            key={"chkTicketPlay1"}
            type="checkbox"
            id="chk1"
            name="chk1Header"
            value="1"
            onClick={(e) => checkedAll(e)}
            raceid={raceInfo.RaceID}
          ></input>{" "}
          1
        </th>
        <th>
          <input
            key={"chkTicketPlay1_1"}
            type="checkbox"
            id="chkTP1"
            name="chkTP1Header"
            value="1"
            onClick={(e) => checkedAll(e)}
            raceid={raceInfo.RaceID}
          ></input>{" "}
          2
        </th>
        <th>
          <input
            type="checkbox"
            id="chkBox"
            name="chkBoxHeader"
            value=""
            key={"box"}
            onClick={(e) => {
              disabledAll(e.target);
            }}
          ></input>{" "}
          Box
        </th>
      </tr>
    );
  }

  let tableWidth;
  if (wt === pickName || wt === WagerTypes.DAILYDOUBLE.name) {
    tableWidth = "380px";
  }
  return (
    <table
      className="table table-striped table-sm"
      style={{ width: { tableWidth } }}
    >
      <thead>{headers}</thead>

      <tbody className="table-sm">{tableContent}</tbody>
    </table>
  );
};

export default EntriesTable;
